import { BuilderComponent } from '@builder.io/react'
import type { BuilderContent } from '@builder.io/sdk'

import getBuilderSplittedBlocks from '@/core/utils/getBuilderSplittedBlocks'
import type { BuilderBlogModel } from '@/models'

import { SplittedBlocks } from './SplittedBlocks'

interface Props {
  data: BuilderBlogModel
  content: BuilderContent
  adsMiddle: BuilderContent
  isPreview: boolean
}

export default function BuilderContentSection({ data, content, adsMiddle, isPreview }: Props) {
  const splittedBlocks = getBuilderSplittedBlocks({ data, content })

  const Component = isPreview ? BuilderComponent : SplittedBlocks

  return <Component blocks={splittedBlocks} content={content} adsMiddle={adsMiddle} />
}
